import React from 'react';
import { injectIntl, WrappedComponentProps } from 'react-intl';

import { PromoCodeNumberOfUseType } from '@/domains';
import { translations } from '@/locale';

import Select, { Props as SelectProps } from '@/components/Select';
import { withValidation } from '@/components/hoc/withValidation';

export interface Props extends Omit<SelectProps<PromoCodeNumberOfUseType>, 'items'>, WrappedComponentProps {}

const PromoCodeNumberOfUseSelect: React.FC<Props> = ({ intl, ...rest }) => {
  const items = Object.values(PromoCodeNumberOfUseType).map((promoCodeNumberOfUseType) => ({
    value: promoCodeNumberOfUseType,
    name: intl.formatMessage({ id: translations.domains.promoCodeNumberOfUseType[promoCodeNumberOfUseType] })
  }));

  return <Select {...rest} items={items} />;
};

const Default = injectIntl(PromoCodeNumberOfUseSelect);
export const PromoCodeNumberOfUseSelectWithValidation = withValidation(Default);
export default Default;
